import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, ProductFullDTO } from '../../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../../../services/util.service';
import { ErrorService } from '../../../../services/error.service';
import { PermissionService } from '../../../../services/permission.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-product-details-attributes',
  templateUrl: './product-details-attributes.component.html',
  styleUrls: ['./product-details-attributes.component.scss'],
  standalone: false,
})
export class ProductDetailsAttributesComponent implements OnInit {
  productId: number;
  product: ProductFullDTO;
  loading: boolean;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.productId = undefined;
    this.product = undefined;
    this.loading = true;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.productId = +params.productID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .pm_Product_retrieveById(this.productId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: ProductFullDTO) => {
          this.product = e;
        },
        error: error => {
          if (!error.status || !(+error.status === 403 || +error.status === 404)) {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }
}
